// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   circularProgressClasses,
//   Stack,
//   TextField,
//   Typography,
//   colors,
//   IconButton,
//   useMediaQuery,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { useTheme } from "@mui/material/styles";
// import { useStateContext } from "../../context/ContextProvider";
// import Animate from "./Common/Animate";
// import logo from "../../assets/images/merchantnewlogo.svg";
// import banner from "../../assets/images/3d-render-tax-payment-financial-business-concept.svg";
// import axios from "axios";
// import baseUrl from "../../config/baseUrl";
// import reload from "../../assets/images/reload.png";

// const Login = () => {

//   const generateCaptcha = () => {
//     const characters = "ABCDEFGHJKMNOPQRSTUVWXYZabcdefghjkmnopqrstuvwxyz0123456789";
//     return Array.from({ length: 6 }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
//   };
  
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const { setIsLoginUser } = useStateContext();
//   const navigate = useNavigate();

//   const [onRequest, setOnRequest] = useState(false);
//   const [loginProgress, setLoginProgress] = useState(0);
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [captchaText, setCaptchaText] = useState(generateCaptcha());
//   const [captchaInput, setCaptchaInput] = useState("");
//   const [captchaValid, setCaptchaValid] = useState(true);

//   const reloadCaptcha = () => {
//     setCaptchaText(generateCaptcha());
//     setCaptchaInput("");
//   };

//   const onSignin = async (e) => {
//     e.preventDefault();

//     if (captchaInput !== captchaText) {
//       setCaptchaValid(false);
//       reloadCaptcha();
//       return;
//     }

//     setCaptchaValid(true);
//     setOnRequest(true);
//     const interval = setInterval(() => {
//       setLoginProgress((prev) => prev + 100 / 40);
//     }, 50);

//     const values = { email: username, password: password };

//     try {
//       const response = await axios.post(`${baseUrl}/login-merchant`, values);
//       if(response){
//         if (response.status === 200) {
//           if(response.data.is_complete === 1){
//             if(response.data.profilestatus === 0) {
//               alert(response.data.message);
//               window.location.reload()
//             } else {
//               setIsLoginUser(response.data.data.token);
//               sessionStorage.setItem("user", response.data.data.token);
//               sessionStorage.setItem("timeZone", JSON.stringify({ name: "India", timeZone: "Asia/Kolkata" }));
//               sessionStorage.setItem("userName", response.data.data.name);
//               sessionStorage.setItem("accoutType", response.data.data?.account_type);
//               sessionStorage.setItem("usercode", response.data.data?.usercode);
//               sessionStorage.setItem("mer", response.data.data?.id);
//               if(response.data.data?.account_type === 1 || response.data.data?.account_type === 0) {
//                 navigate("/DepositPortal/merchant_deposits");
//               } else {
//                 navigate("/DepositPortal/dashboard");
//               }
//             }
//           } else {
//             alert("Please Complete Your Profile First");
//             sessionStorage.setItem("authToken", response.data.data.token);
//             navigate("/DepositPortal/incomplete_profile");
//           }
//         } else {
//           alert(response.data.message);
//           reloadCaptcha();
//         }
//       }
//     } catch (error) {
//       console.error("Login error:", error);
//       alert("An error occurred during login.");
//       reloadCaptcha();
//     } finally {
//       clearInterval(interval);
//       setOnRequest(false);
//     }
//   };
  
//   return (
//     <Box display="flex" flexDirection={{ xs: "column", md: "row" }} minHeight="100vh">
//       {/* Desktop Banner */}
//       <Box
//         sx={{
//           width: "70%",
//           height: "100vh",
//           backgroundImage: `url(${banner})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           display: { xs: "none", md: "block" },
//         }}
//       />

//       <Box
//         sx={{
//           width: { xs: "100%", md: "30%" },
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           bgcolor: "#ffffffcc", // slight transparency for glass effect
//           backdropFilter: "blur(8px)",
//           boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
//           borderRadius: "12px",
//           padding: { xs: 3, md: 5 },
//         }}
//       >
//         <Box sx={{ textAlign: "center", mb: 3 }}>
//           <Animate type="fade">
//             <img src={logo} alt="logo" height={70} />
//           </Animate>
//         </Box>

//         {isMobile && (
//           <Box
//             sx={{
//               width: "100%",
//               height: 180,
//               backgroundImage: `url(${banner})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               mb: 3,
//               borderRadius: "12px",
//               boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
//             }}
//           />
//         )}

//         <Animate type="fade" sx={{ width: "100%", maxWidth: 400 }}>
//           <Box component="form" onSubmit={onSignin}>
//             <Stack spacing={3}>
//               <TextField
//                 label="Username"
//                 fullWidth
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//               />
//               <TextField
//                 label="Password"
//                 type="password"
//                 fullWidth
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//               />
//               <Stack direction="row" spacing={1} alignItems="center">
//                 <Typography
//                   sx={{
//                     backgroundColor: "#e6f4ea",
//                     border: "2px dashed #81c784",
//                     px: 2,
//                     py: 1,
//                     borderRadius: 2,
//                     fontWeight: 700,
//                     letterSpacing: "3px",
//                     fontSize: "1.4rem",
//                     flex: 1,
//                     textAlign: "center",
//                     userSelect: "none",
//                   }}
//                 >
//                   {captchaText}
//                 </Typography>
//                 <TextField
//                   label="Captcha"
//                   value={captchaInput}
//                   onChange={(e) => setCaptchaInput(e.target.value)}
//                   error={!captchaValid}
//                   helperText={!captchaValid ? "Incorrect Captcha" : ""}
//                 />
//                 <IconButton onClick={reloadCaptcha}>
//                   <img src={reload} alt="reload" width={28} />
//                 </IconButton>
//               </Stack>

//               <Typography
//                 variant="body2"
//                 align="right"
//                 onClick={() => navigate("/DepositPortal/forgot_password")}
//                 sx={{
//                   fontWeight: 800,
//                   color: 'gray',
//                   cursor: 'pointer',
//                   mb: 0,
//                   '&:hover': {
//                     color: '#1976D2',
//                   },
//                 }}
//               >
//                 Forgot Password?
//               </Typography>

//               <Button
//                 type="submit"
//                 variant="contained"
//                 fullWidth
//                 size="large"
//                 sx={{
//                   background: "linear-gradient(to right, #43cea2, #185a9d)",
//                   color: "#fff",
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   py: 1.5,
//                   "&:hover": {
//                     background: "linear-gradient(to right, #2bc0e4, #eaecc6)",
//                     color: "#000",
//                   },
//                 }}
//               >
//                 SIGN IN
//               </Button>

//               <Typography textAlign="center">
//                 Don't have an account?{" "}
//                 <Button
//                   onClick={() => navigate("/DepositPortal/signup-merchant")}
//                   sx={{
//                     fontWeight: "bold",
//                     textTransform: "none",
//                     color: "#1976d2",
//                   }}
//                 >
//                   Register
//                 </Button>
//               </Typography>
//             </Stack>
//           </Box>
//         </Animate>

//         {onRequest && (
//           <Stack
//             alignItems="center"
//             justifyContent="center"
//             sx={{
//               position: "fixed",
//               top: 0,
//               left: 0,
//               width: "100vw",
//               height: "100vh",
//               bgcolor: "#ffffffd9",
//               zIndex: 1000,
//             }}
//           >
//             <Box position="relative">
//               <CircularProgress variant="determinate" size={100} value={100} sx={{ color: "#f0f0f0" }} />
//               <CircularProgress
//                 variant="determinate"
//                 value={loginProgress}
//                 size={100}
//                 sx={{
//                   position: "absolute",
//                   left: 0,
//                   color: "#43cea2",
//                   [`& .${circularProgressClasses.circle}`]: {
//                     strokeLinecap: "round",
//                   },
//                 }}
//               />
//             </Box>
//             <Typography mt={2} fontWeight={600}>
//               Logging in...
//             </Typography>
//           </Stack>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default Login;


import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  circularProgressClasses,
  Stack,
  TextField,
  Typography,
  colors,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useStateContext } from "../../context/ContextProvider";
import Animate from "./Common/Animate";
import logo from "../../assets/images/merchantnewlogo.svg";
import banner from "../../assets/images/3d-render-tax-payment-financial-business-concept.svg";
import axios from "axios";
import baseUrl from "../../config/baseUrl";
import reload from "../../assets/images/reload.png";

const Login = () => {

  const generateCaptcha = () => {
    const characters = "ABCDEFGHJKMNOPQRSTUVWXYZabcdefghjkmnopqrstuvwxyz0123456789";
    return Array.from({ length: 6 }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
  };
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { setIsLoginUser } = useStateContext();
  const navigate = useNavigate();

  const [onRequest, setOnRequest] = useState(false);
  const [loginProgress, setLoginProgress] = useState(0);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [captchaText, setCaptchaText] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaValid, setCaptchaValid] = useState(true);

  const [otp, setOtp] = useState("");

  const reloadCaptcha = () => {
    setCaptchaText(generateCaptcha());
    setCaptchaInput("");
  };

  const onSignin = async (e) => {
    e.preventDefault();

    if (captchaInput !== captchaText) {
      setCaptchaValid(false);
      reloadCaptcha();
      return;
    }

    setCaptchaValid(true);
    setOnRequest(true);
    const interval = setInterval(() => {
      setLoginProgress((prev) => prev + 100 / 40);
    }, 50);

    const values = { email: username, password: password, otp: otp };

    if (otp.length !== 6) {
      alert("Please enter valid 6-digit OTP");
      return;
    }

    try {
      const response = await axios.post(`${baseUrl}/login-merchant`, values);
      if(response){
        if (response.status === 200) {
          if(response.data.is_complete === 1){
            if(response.data.profilestatus === 0) {
              alert(response.data.message);
              window.location.reload()
            } else {
              setIsLoginUser(response.data.data.token);
              sessionStorage.setItem("user", response.data.data.token);
              sessionStorage.setItem("timeZone", JSON.stringify({ name: "India", timeZone: "Asia/Kolkata" }));
              sessionStorage.setItem("userName", response.data.data.name);
              sessionStorage.setItem("accoutType", response.data.data?.account_type);
              sessionStorage.setItem("usercode", response.data.data?.usercode);
              sessionStorage.setItem("mer", response.data.data?.id);
              if(response.data.data?.account_type === 1 || response.data.data?.account_type === 0) {
                navigate("/DepositPortal/merchant_deposits");
              } else {
                navigate("/DepositPortal/dashboard");
              }
            }
          } else {
            alert("Please Complete Your Profile First");
            sessionStorage.setItem("authToken", response.data.data.token);
            navigate("/DepositPortal/incomplete_profile");
          }
        } else {
          alert(response.data.message);
          reloadCaptcha();
        }
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("An error occurred during login.");
      reloadCaptcha();
    } finally {
      clearInterval(interval);
      setOnRequest(false);
    }
  };
  
  return (
    <Box display="flex" flexDirection={{ xs: "column", md: "row" }} minHeight="100vh">
      {/* Desktop Banner */}
      <Box
        sx={{
          width: "70%",
          height: "100vh",
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: { xs: "none", md: "block" },
        }}
      />

      <Box
        sx={{
          width: { xs: "100%", md: "30%" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "#ffffffcc", // slight transparency for glass effect
          backdropFilter: "blur(8px)",
          boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
          borderRadius: "12px",
          padding: { xs: 3, md: 5 },
        }}
      >
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Animate type="fade">
            <img src={logo} alt="logo" height={70} />
          </Animate>
        </Box>

        {isMobile && (
          <Box
            sx={{
              width: "100%",
              height: 180,
              backgroundImage: `url(${banner})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              mb: 3,
              borderRadius: "12px",
              boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
            }}
          />
        )}

        <Animate type="fade" sx={{ width: "100%", maxWidth: 400 }}>
          <Box component="form" onSubmit={onSignin}>
            <Stack spacing={3}>
              <TextField
                label="Username"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <TextField
                label="Password"
                type="password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <TextField
                label="Google Authenticator Code"
                fullWidth
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                inputProps={{ maxLength: 6 }}
              />
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography
                  sx={{
                    backgroundColor: "#e6f4ea",
                    border: "2px dashed #81c784",
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    fontWeight: 700,
                    letterSpacing: "3px",
                    fontSize: "1.4rem",
                    flex: 1,
                    textAlign: "center",
                    userSelect: "none",
                  }}
                >
                  {captchaText}
                </Typography>
                <TextField
                  label="Captcha"
                  value={captchaInput}
                  onChange={(e) => setCaptchaInput(e.target.value)}
                  error={!captchaValid}
                  helperText={!captchaValid ? "Incorrect Captcha" : ""}
                />
                <IconButton onClick={reloadCaptcha}>
                  <img src={reload} alt="reload" width={28} />
                </IconButton>
              </Stack>

              <Typography
                variant="body2"
                align="right"
                onClick={() => navigate("/DepositPortal/forgot_password")}
                sx={{
                  fontWeight: 800,
                  color: 'gray',
                  cursor: 'pointer',
                  mb: 0,
                  '&:hover': {
                    color: '#1976D2',
                  },
                }}
              >
                Forgot Password?
              </Typography>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                size="large"
                sx={{
                  background: "linear-gradient(to right, #43cea2, #185a9d)",
                  color: "#fff",
                  fontWeight: 600,
                  borderRadius: 2,
                  py: 1.5,
                  "&:hover": {
                    background: "linear-gradient(to right, #2bc0e4, #eaecc6)",
                    color: "#000",
                  },
                }}
              >
                SIGN IN
              </Button>

              <Typography textAlign="center">
                Don't have an account?{" "}
                <Button
                  onClick={() => navigate("/DepositPortal/signup-merchant")}
                  sx={{
                    fontWeight: "bold",
                    textTransform: "none",
                    color: "#1976d2",
                  }}
                >
                  Register
                </Button>
              </Typography>
            </Stack>
          </Box>
        </Animate>

        {onRequest && (
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              bgcolor: "#ffffffd9",
              zIndex: 1000,
            }}
          >
            <Box position="relative">
              <CircularProgress variant="determinate" size={100} value={100} sx={{ color: "#f0f0f0" }} />
              <CircularProgress
                variant="determinate"
                value={loginProgress}
                size={100}
                sx={{
                  position: "absolute",
                  left: 0,
                  color: "#43cea2",
                  [`& .${circularProgressClasses.circle}`]: {
                    strokeLinecap: "round",
                  },
                }}
              />
            </Box>
            <Typography mt={2} fontWeight={600}>
              Logging in...
            </Typography>
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default Login;
